import { render, staticRenderFns } from "./DeleteRegiaoModal.vue?vue&type=template&id=54ce63b4&scoped=true&lang=pug"
import script from "./DeleteRegiaoModal.vue?vue&type=script&lang=js"
export * from "./DeleteRegiaoModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteRegiaoModal.vue?vue&type=style&index=0&id=54ce63b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ce63b4",
  null
  
)

export default component.exports